<template>
  <div class="app-development">
    <div class="content">
      <MarkdownMobileView :textData="textData" :title="title" />
    </div>
  </div>
</template>

<script>
import MarkdownMobileView from "@/views/phone/components/MarkdownMobileView.vue";
import { deviceDoc } from "@/data/deviceDoc";

export default {
  name: "DeviceView",
  components: {
    MarkdownMobileView,
  },
  watch: {
    $route(to, from) {
      console.log("to", to.path);
      console.log("from", from.path);
      this.textData = this.findNodeByPath(this.data, to.path)?.data || "";
      this.title = this.findNodeByPath(this.data, to.path)?.label || "";
    },
  },

  methods: {
    findNodeByPath(data, path) {
      for (const item of data) {
        if (item.path === path) {
          return item;
        }
        if (item.children) {
          const found = this.findNodeByPath(item.children, path);
          if (found) return found;
        }
      }
      return null;
    },
  },

  mounted() {
    console.log("this.$route.path", this.$route.path);
    this.textData =
      this.findNodeByPath(this.data, this.$route.path)?.data || "";
    this.title = this.findNodeByPath(this.data, this.$route.path)?.label || "";
    this.$emit("sendData", this.data);
  },

  data() {
    return {
      data: deviceDoc,
      defaultProps: {
        children: "children",
        label: "label",
        key: "id", // 设置key字段
      },
      textData: "",
      title: "",
    };
  },
};
</script>

<style scoped>
.filter-tree {
  margin-top: 32px;
  font-weight: 500;
  font-size: 14px;
  color: #1f2937;
  text-align: left;
}

::v-deep .nav-left .el-input__inner::placeholder {
  font-weight: 500;
  font-size: 15px;
  color: #6b7280;
  text-align: left;
  color: #6b7280;
  padding-left: 8px;
}

::v-deep .filter-tree .el-tree-node__content:hover {
  background-color: transparent;
}

::v-deep .filter-tree .el-tree-node__content {
  background-color: #fff !important;
  height: 36px;
}

.app-development {
  display: flex;
  height: 100%;
}

.nav-left {
  width: 260px;
  padding: 20px;
  border-right: 1px solid #e5e7eb;
}

.tree_text {
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: left;
  padding: 0 10px;
  border-radius: 4px;
}

.tree_text:hover {
  background-color: #f3f4f6;
}

.tree_text.text-is-current {
  background-color: #f3f4f6;
}
</style>
